module.exports = __webpack_public_path__ + "img/serve.d17d051f.png";